import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { sharedClasses } from '@/components/NewUI/Components';
import { styles } from '../styles';

export const renderAutocomplete = <T extends { name: string }>(
  label: string,
  value: T | null,
  options: T[],
  onChange: (value: T | null) => void,
  disabled = false,
  error = false,
  helperText?: string,
  ref?: React.RefObject<HTMLInputElement>
) => (
  <Autocomplete
    disablePortal
    value={value}
    options={options}
    getOptionLabel={(option) => option.name}
    onChange={(_event, newValue) => onChange(newValue)}
    disabled={disabled}
    sx={{
      ...sharedClasses.formAutocomplete,
      width: '100%',
      paddingTop: 3,
      '.MuiInputBase-root': { margin: '3px 0px' }
    }}
    slotProps={{ listbox: { style: sharedClasses.autoCompleteListStyles } }}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        slotProps={{ inputLabel: { shrink: true } }}
        placeholder="Please select"
        sx={styles.editCandidateAutocompleteTextfield}
        required={error}
        error={error}
        helperText={helperText}
        ref={ref}
      />
    )}
  />
);
